// This file was automatically generated from practicedata.appts.html.
// Please don't edit this file by hand.

goog.provide('el8.template.practicedata.appts');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.practicedata.appts.typeTag = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8TagItem mr5" style="', (opt_data.color) ? 'background-color:' + soy.$$escapeHtml(opt_data.color) : '', '">');
  el8.template.practicedata.appts.typeTagText(opt_data, output);
  output.append('</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.practicedata.appts.typeTagText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.abbreviation) ? soy.$$escapeHtml(opt_data.abbreviation) : soy.$$escapeHtml(opt_data.name.substring(0,8)));
  if (!opt_sb) return output.toString();
};
